module.exports = __webpack_public_path__ + "img/withu-app.cc20f8fe.png";